import { AfterContentInit, Component, forwardRef, input, contentChildren } from '@angular/core';

import { MenuItem } from 'primeng/api';
import { PCPWizardStepComponent } from './wizardstep/pcpwizardstep.component';
import { StepsModule } from 'primeng/steps';

@Component({
    selector: 'pcp-wizard',
    templateUrl: './pcpwizard.component.html',
    styleUrls: ['./pcpwizard.component.scss'],
    standalone: true,
    imports: [StepsModule]
})
export class PCPWizardComponent implements AfterContentInit {
    activeStep: number = 0;
    steps: MenuItem[];
    numOfSteps: number = -1;

    readonly contentClass = input<string>(undefined);

    readonly wizardSteps = contentChildren(forwardRef(() => PCPWizardStepComponent), { descendants: true });
    
    ngAfterContentInit(): void {
        this.numOfSteps = this.wizardSteps.length - 1;
        this.steps = this.wizardSteps().map((step, index) => { 
            step.stepNumber = index;
            return { label: step.title(), styleClass: step.colClass() };
        });
    }

    next(): void {
        this.activeStep++;
        this.onActiveStepChange();
    }

    back(): void {
        this.activeStep--;
        this.onActiveStepChange();
    }

    done(): void {
        this.activeStep = 0;
        this.onActiveStepChange();
    }

    private onActiveStepChange(): void {
        this.setActiveStep();
        this.toggleStepsVisibility();
    }

    private toggleStepsVisibility(): void {
        if(this.activeStep === this.numOfSteps) {
            this.wizardSteps().forEach(step => {
                step.hidden = step.stepNumber < this.activeStep;
            });
        } else {
            this.wizardSteps().forEach(step => step.hidden = false);
        }
    }

    private setActiveStep(): void {
        this.wizardSteps().forEach(step => step.activeStep = this.activeStep);
    }
}

